var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecreasinggraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 361 95",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M360 84L307.364 94.0487C305.87 94.3339 304.327 93.9235 303.173 92.9336L269.473 64.0486C267.727 62.5518 265.185 62.4394 263.313 63.7762L237.97 81.8784C236.201 83.1423 233.817 83.1176 232.074 81.8173L175.085 39.3015C173.267 37.9449 170.763 37.9827 168.986 39.3936L124.733 74.5354C122.643 76.1951 119.618 75.9209 117.861 73.9124L62.725 10.9C61.9348 9.99692 60.8461 9.40813 59.6578 9.24118L1 1",
    stroke: "url(#paint0_linear_7152_22444)",
    strokeWidth: 1.46183
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7152_22444",
    x1: 180.5,
    y1: 1,
    x2: 180.5,
    y2: 94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD1E11"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecreasinggraph);
export default __webpack_public_path__ + "static/media/decreasinggraph.f2fc7b9321def4e8c115e1ee95dcbfc0.svg";
export { ForwardRef as ReactComponent };